import { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Observer from 'react-intersection-observer';
import cns from 'classnames';
import { noop } from 'lodash/fp';

import Section from 'components/Section';
import BackLink from 'components/BackLink';
import Breadcrumbs from 'components/Breadcrumbs';
import ActiveFiltersList from '../../ActiveFiltersList';
import FilterBlocks from '../../FilterBlocks';
import StickyFooter from './StickyFooter';
import cn from './styles.local.less';

export default class ExtraFiltersContent extends Component {
  static propTypes = {
    activeFilters: PropTypes.object.isRequired,
    cmsContent: PropTypes.object,
    formName: PropTypes.string.isRequired,
    onAdvFiltersSubmit: PropTypes.func,
    onFiltersItemRemove: PropTypes.func.isRequired,
    onMount: PropTypes.func,
    onRemoveAll: PropTypes.func,
  };

  static defaultProps = {
    onMount: noop,
  };

  state = { isFooterIntersected: false };

  UNSAFE_componentWillMount() {
    this.props.onMount();
  }

  handleObserverChange = (isFooterIntersected) => {
    this.setState({
      isFooterIntersected,
    });
  };

  render() {
    const {
      activeFilters,
      cmsContent,
      formName,
      onAdvFiltersSubmit,
      onFiltersItemRemove,
      onRemoveAll,
    } = this.props;

    const { breadcrumbs } = cmsContent;
    const { isFooterIntersected } = this.state;

    return (
      <Fragment>
        <div className={cns(cn.backLinkContainer, 'back-link-container')}>
          <BackLink forceRefresh={false}>{__('common.backToSearch')}</BackLink>
        </div>

        <h2 className={cn.title}>{__('search.advTitle')}</h2>

        <ActiveFiltersList
          className={cns(cn.activeFilterContainer, 'hidden-sm', 'hidden-xs')}
          onRemoveAllClick={onRemoveAll}
          onItemRemove={onFiltersItemRemove}
          filters={activeFilters}
        />

        <FilterBlocks formName={formName} />
        <Observer threshold={0} onChange={this.handleObserverChange}>
          <StickyFooter
            isSticky={!isFooterIntersected}
            onSubmit={onAdvFiltersSubmit}
          />
        </Observer>

        <Section>
          <Breadcrumbs items={breadcrumbs} />
        </Section>
      </Fragment>
    );
  }
}
